<template>
  <div class="page">
    <commonHeader heading="数据概览" subtitle="学员学习数据">
      <template v-slot:icon>
        <span class="iconfont icon-fanhui back" @click="goBack()"></span>
      </template>
    </commonHeader>
    <!-- 学员学习数据 -->
    <div class="big-title">
      <div class="left-title">学员学习数据</div>
    </div>
    <div class="table-data">
      <v-card>
        <div class="table-header">
          <v-text-field class="text-field-width" v-model="queryParams.name" placeholder="请输入学员名称" hide-details solo
            clearable></v-text-field>
          <v-text-field class="text-field-width" v-model="queryParams.name1" placeholder="请输入学员账号" hide-details solo
            clearable></v-text-field>
          <v-btn depressed color="primary">
            搜索
          </v-btn>
          <v-btn depressed>
            清空
          </v-btn>
        </div>
        <div class="table-content">
          <v-data-table hide-default-footer :headers="headers" :items="desserts" :items-per-page="5"
            class="elevation-1"></v-data-table>
        </div>
        <div class="table-paging">
          <v-pagination class="table-pagination" prev-icon="fa fa-angle-left" next-icon="fa fa-angle-right"
            color="#4caf50" :value="pagination.page" :length="1" circle :total-visible="7"></v-pagination>
        </div>
      </v-card>
    </div>

  </div>
</template>

<script>
import CommonHeader from '@/components/DataService/CommonHeader.vue';
export default {
  components: {
    CommonHeader
  },
  data() {
    return {
      queryParams: {
        name: '',
        name1: '',
        select: '',
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      },
      selectMetaListData: [{ text: '水电费', value: 1 }, { text: '让突然', value: 2 }],

      dateMenu: false,
      headers: [
        {
          text: '学员',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        { text: '账号', value: 'calories',sortable: false },
        { text: '选课数', value: 'fat', sortable: false },
        { text: '首次学习时间', value: 'carbs', sortable: false, width: 160 },
        { text: '最后学习时间', value: 'protein', sortable: false, width: 160 },
        { text: '总在线时间', value: 'iron1', sortable: false, width: 100 },
        { text: '学习课程任务数', value: 'iron2', sortable: false },
        { text: '完成任务学习率', value: 'iron3', sortable: false },
        { text: '课程完成率', value: 'iron4', sortable: false },
        { text: '学习力等级', value: 'iron5', sortable: false },
      ],
      desserts: [
        {
          name: '张明',
          calories: 15963259873,
          fat: 28,
          carbs: '2024-07-31 17:16:56',
          protein: '2024-08-10 17:16:56',
          iron1: '300',
          iron2: '10',
          iron3: '80%',
          iron4: '85%',
          iron5: '5',
        },
      ],
      pagination: {
        page: 1,
        itemsPerPage: 8,
        total: 0,
        // name: "",
        perPageOptions: [8, 12, 16, 20],
      },


    };
  },

  created() {

  },

  mounted() {
    this.getTableList()
  },

  methods: {
    goBack() {
      this.$router.push({
        name: 'DataSummary',
      });
    },
    getTableList() { },

  }
}
</script>

<style scoped>
.page {
  padding: 0 15px;

  .big-title {
    display: flex;
    padding: 15px 15px 5px 15px;

    .left-title {    
      height: 30px;
      line-height: 30px;
      font-size: 18px;
      flex: 1;
      text-align: left;
    }

    .right-return {
      text-align: right;
      font-size: 18px;
    }
  }

  .table-data {
    .v-card {
      padding: 15px;
    }

    .table-header {
      .text-field-width {
        display: inline-block;
        width: 200px;
        margin: 0 5px 5px 0;
      }

      .select-width {
        display: inline-block;
        width: 260px;
        margin: 0 5px 5px 0;
      }

      .date-width {
        display: inline-block;
        width: 260px;
        margin: 0 5px 5px 0;
      }

      .v-btn {
        margin: 5px;
      }
    }

    .table-content {
      padding: 10px 0;
    }

    .table-paging {
      overflow: hidden;
      text-align: right;

      .table-pagination {
        float: right;
      }
    }
  }
}
</style>